module.exports = __webpack_public_path__ + "static/media/Sempione - Ind.Blue - Orange_GR Green.d3c4b29d.jpg";